import { Flex } from '@comet/blocks';
import { styled } from '@comet/styled';

export const DetailsTag = styled(Flex)`
  background: ${({ theme }) => theme.palette.neutral.lighter};
  padding: 4px 8px;
  border-radius: ${({ theme }) => theme.constants.borderRadius.lg};
`;
